import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import { renderCheckbox, renderNewTextField, renderErrorInfoText } from '../../common/forms/FieldCreators';
import { RouteComponentProps } from 'react-router';
import { Form, Control, Errors } from 'react-redux-form';
import { RegisterUserModel } from './RegisterUserModels';
import FormItem from '../../components/forms/FormItem';
import { ContactModel } from '../../common/models/CommonModels';
import nameof from '../../utils/nameof';
import * as Store from "./registerUserStore";
import { ApplicationState } from '../../store';
import RegistrationCompleted from './RegistrationCompleted';
import { localizations } from '../../localization/localization';
import * as validators from '../../common/validators/formValidators'
import pdf from '../privacy/Kayttoehdot-UnitSpotter_20180925.pdf'
import gdpr from '../privacy/Tietosuojaseloste-UnitSpotter.pdf'

interface FormState {
    termsAccepted: boolean;
}

interface RouteMatchProps {
    identifier: string;
}

// Create terms label with links.
const termsLabel = <div className="privacyLabel">
    Hyväksyn palvelun <a href = {pdf} target = "_blank">Käyttöehdot.</a>
</div >;

const consentForm = <div>
    Yksityisyytesi ja tietojesi suojaaminen on meille tärkeää. Lue lisää <a href = {gdpr} target = "_blank">tietosuojalausekkeestamme.</a>
</div >;


type RegisterUserFormProps = FormState & typeof Store.actionCreators & Store.RegisterUserState & RouteComponentProps<RouteMatchProps>;

class RegisterUserForm extends React.Component<RegisterUserFormProps> {

    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        this.props.registerUserRequest(this.props.match.params.identifier);
    }

    public render() {
        const { termsAccepted, success } = this.props;

        return <Grid className="loginContent">
            {success ? <RegistrationCompleted
                title={localizations.register.thanksForRegistering}
                information={localizations.register.registeringSuccessfulParagraph}
                continueButtonLabel={localizations.register.continueToLogin}
                onContinue={this.props.registerUserContinueToLogin}
            /> : <Form hideNativeErrors model="registerUserModel" onSubmit={this.props.registerUserSubmitted}>
                    <Typography paragraph variant="h4">{localizations.register.registerUserTitle}</Typography>
                    <FormItem><Control model=".company" label="Yritys" component={renderNewTextField} disabled /></FormItem>
                    <FormItem><Control required validators={{ required: validators.required }} validateOn={["blur", "change"]} model={`.${nameof<RegisterUserModel>("firstName")}`} label={localizations.common.firstName} component={renderNewTextField} />
                        <Errors model={`.${nameof("firstName")}`} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                    </FormItem>
                    <FormItem>
                        <Control required model={`.${nameof<RegisterUserModel>("lastName")}`} label={localizations.common.lastName} component={renderNewTextField} />
                        <Errors model={`.${nameof("lastName")}`} show={{ touched: true, focus: false }} messages={{ required: localizations.validation.required }} wrapper={renderErrorInfoText} />
                    </FormItem>
                    <FormItem>
                        <Control required model={`.contact.${nameof<ContactModel>("email")}`} label={localizations.common.email} component={renderNewTextField} />
                        <Errors model={`.contact.${nameof<ContactModel>("email")}`} show={{ touched: true, focus: false }} messages={{ isEmail: localizations.validation.notAnEmail }} wrapper={renderErrorInfoText} />
                    </FormItem>
                    <FormItem>
                        <Control required validators={{ isPhoneNumber: validators.isPhoneNumber }} validateOn={["blur", "change"]} model={`.contact.${nameof<ContactModel>("phoneNumber")}`} label={localizations.common.phoneNumber} component={renderNewTextField} />
                        <Errors model={`.contact.${nameof<ContactModel>("phoneNumber")}`} show={{ touched: true, focus: false }} messages={{ isPhoneNumber: localizations.validation.notAPhoneNumber }} wrapper={renderErrorInfoText} />
                    </FormItem>
                    <br />
                    <FormControlLabel label={termsLabel} control={<Control.checkbox model=".termsAccepted" id="termsAccepted" component={renderCheckbox} />} />
                    <Typography> {consentForm} </Typography>
                    <br />
                    <br />
                    <FormItem><Button variant="contained" type="submit" color="primary" disabled={!termsAccepted}>Rekisteröidy</Button></FormItem>
                </Form>}
        </Grid >;
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        termsAccepted: state.forms.registerUserModel.termsAccepted.value,
        success: state.registerUser.success
    }
}

export default connect(mapStateToProps, Store.actionCreators)(RegisterUserForm);


// WEBPACK FOOTER //
// ./src/register/user/RegisterUserForm.tsx